import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { AclCategoryFieldComponent } from "./acl-category.component";
import { AclCategoryModalComponent } from "./acl-category-modal.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        AclCategoryFieldComponent,
        AclCategoryModalComponent
    ],
    exports: [
        AclCategoryFieldComponent
    ],
    entryComponents: [
        AclCategoryModalComponent
    ]
})
export class AclCategoryModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/acl-category/form/acl-category.module.ts